import { render, staticRenderFns } from "./ValidationControls.vue?vue&type=template&id=3dd9f140&scoped=true&"
import script from "./ValidationControls.vue?vue&type=script&lang=js&"
export * from "./ValidationControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd9f140",
  null
  
)

export default component.exports